import {startsWith} from 'lodash';

export function isActivePath(pathsToCheck: (string | undefined)[], location: {pathname: string}) {
  return pathsToCheck.some((path) => startsWith(location.pathname, path));
}
